<template>
  <user-profile
    v-if="profileInfo"
    :is-new-profile="false"
    :user-profile-information="profileInfo"
  />
</template>

<script>
//components
import UserProfile from '@/views/register/RegisterView.vue';

//services
import { getProfileInformation as _getProfileInformation } from '@/services/app.api.js';
import { getUserProfile as _getUserProfile } from '@/services/auth.api.js';

export default {
  name: 'UserProfileView',
  components: {
    UserProfile,
  },
  data: () => ({
    profileInfo: null,
  }),
  async mounted() {
    this.disposeCaseInfo();
    await this.getProfileInformation();
  },
  methods: {
    async getProfileInformation() {
      //Validate if userId is present in the route
      if (this.$route.params.userId) {
        this.profileInfo = (
          await _getUserProfile(this.$route.params.userId)
        ).data;
      } else {
        this.profileInfo = (await _getProfileInformation()).data;
      }
    },
  },
};
</script>
